// Export the main purchase tracking function
export function initializeThankYou() {
    const THANK_YOU_SERVER_URL = 'revenue-node-server.vercel.app';
// Function to get a cookie by name
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Function to set a cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

// Function to get a meta tag content by name
function getMetaContentByName(name) {
    const metaTag = document.querySelector(`meta[name="${name}"]`);
    return metaTag ? metaTag.getAttribute('content') : null;
}

function isSetupCheck() {
    try {
        return new URLSearchParams(window.location.search).get('rtverify') === '1';
    } catch (e) {
        return false;
    }
}
function trackingHost(fallback) {
    if (!isSetupCheck()) return fallback;
    try {
        const host = new URLSearchParams(window.location.search).get('rthost');
        const allowedHost = host === 'revenue-node-server.vercel.app'
            || /^revenue-node-server-[a-z0-9]+-tuomaskiviojas-projects\.vercel\.app$/.test(host || '');
        return allowedHost ? host : fallback;
    } catch (e) {
        return fallback;
    }
}


function pingSetupCheck(status) {
    if (!isSetupCheck()) return;
    let params;
    try {
        params = new URLSearchParams(window.location.search);
    } catch (e) {
        return;
    }
    const username = getMetaContentByName('username') || params.get('rtuser');
    if (!username) return;
    const offer = getMetaContentByName('offer') || params.get('utm_offer') || '';
    const step = params.get('rtstep') || '';
    const host = params.get('rthost');
    const allowedHost = host === 'revenue-node-server.vercel.app'
        || /^revenue-node-server-[a-z0-9]+-tuomaskiviojas-projects\.vercel\.app$/.test(host || '');
    const pingHost = allowedHost ? host : THANK_YOU_SERVER_URL;
    fetch('https://' + pingHost + '/api/setup-check-ping/' + encodeURIComponent(username), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ offer: offer, step: step, status: status === 'success' ? 'success' : 'loaded' })
    }).catch(function () {});
}

function setupBannerStyle(mode) {
    const success = mode === 'success';
    const failure = mode === 'failure';
    return [
        'position:fixed', 'bottom:24px', 'left:50%', 'transform:translateX(-50%)',
        'z-index:2147483647', 'display:flex',
        failure ? 'flex-direction:column' : 'flex-direction:row',
        failure ? 'align-items:stretch' : 'align-items:center',
        'gap:14px', 'box-sizing:border-box',
        'min-width:min(460px, calc(100% - 32px))', 'max-width:calc(100% - 32px)',
        'padding:22px 28px', 'background:#021220', 'color:#f3f4f6',
        success ? 'border:2px solid #00F2A5' : failure ? 'border:2px solid #f87171' : 'border:2px solid #00D3F2',
        'border-radius:16px', 'font:600 18px/1.35 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif',
        success ? 'box-shadow:0 12px 40px rgba(0,0,0,.45), 0 0 0 6px rgba(0,242,165,.15)'
            : failure ? 'box-shadow:0 12px 40px rgba(0,0,0,.45), 0 0 0 6px rgba(248,113,113,.16)'
            : 'box-shadow:0 12px 40px rgba(0,0,0,.45), 0 0 0 6px rgba(0,211,242,.18)'
    ].join(';');
}

function ensureSetupCheckBanner() {
    if (!isSetupCheck()) return null;
    const existing = document.getElementById('revtrack-setup-banner');
    if (existing) return existing;
    if (!document.getElementById('revtrack-setup-banner-style')) {
        const style = document.createElement('style');
        style.id = 'revtrack-setup-banner-style';
        style.textContent = '@keyframes revtrack-setup-spin{to{transform:rotate(360deg)}}';
        (document.head || document.documentElement).appendChild(style);
    }
    const el = document.createElement('div');
    el.id = 'revtrack-setup-banner';
    el.setAttribute('style', setupBannerStyle('checking'));
    const spinner = document.createElement('span');
    spinner.setAttribute('style', 'width:22px;height:22px;flex:none;border-radius:50%;border:3px solid rgba(0,211,242,.25);border-top-color:#00D3F2;animation:revtrack-setup-spin .8s linear infinite');
    const label = document.createElement('span');
    label.textContent = 'Checking for script...';
    el.appendChild(spinner);
    el.appendChild(label);
    const mount = function () {
        if (document.body && !document.getElementById('revtrack-setup-banner')) document.body.appendChild(el);
    };
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount);
    return el;
}

function getOfferTagStatus() {
    const offer = getMetaContentByName('offer');
    if (!offer || !String(offer).trim()) return { ok: false, detail: 'Missing' };
    let expected = '';
    try { expected = new URLSearchParams(window.location.search).get('utm_offer') || ''; } catch (e) {}
    if (expected && offer.trim() !== expected.trim()) return { ok: false, detail: 'Does not match this offer' };
    return { ok: true, detail: 'Found' };
}

function setupCheckMark(ok) {
    const mark = document.createElement('span');
    mark.setAttribute('style', 'width:22px;height:22px;flex:none;border-radius:6px;display:flex;align-items:center;justify-content:center;background:' + (ok ? '#00F2A5' : '#f87171'));
    mark.innerHTML = ok
        ? '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3.5 8.2l3 3.1 6-6.6" stroke="#021220" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M4 4l8 8M12 4l-8 8" stroke="#021220" stroke-width="2.2" stroke-linecap="round"/></svg>';
    return mark;
}

function showSetupCheckSuccess() {
    if (!getOfferTagStatus().ok) {
        showSetupCheckFailure(true);
        return;
    }
    pingSetupCheck('success');
    const el = ensureSetupCheckBanner();
    if (!el) return;
    el.setAttribute('style', setupBannerStyle('success'));
    el.textContent = '';
    const box = document.createElement('span');
    box.setAttribute('style', 'width:28px;height:28px;flex:none;border-radius:7px;background:#00F2A5;display:flex;align-items:center;justify-content:center');
    box.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3.5 8.2l3 3.1 6-6.6" stroke="#021220" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const label = document.createElement('span');
    label.textContent = 'Test conversion recorded - your script is working';
    el.appendChild(box);
    el.appendChild(label);
}

function showSetupCheckFailure(conversionRecorded) {
    const el = ensureSetupCheckBanner();
    if (!el) return;
    const username = getMetaContentByName('username');
    const hasUsername = !!(username && String(username).trim());
    const offerStatus = getOfferTagStatus();
    const rows = [
        { ok: offerStatus.ok, label: 'Offer tag', detail: offerStatus.detail },
        { ok: hasUsername, label: 'Username tag', detail: hasUsername ? 'Found' : 'Missing' },
        { ok: true, label: 'Script', detail: 'Found' }
    ];
    if (conversionRecorded) rows.push({ ok: true, label: 'Conversion recorded', detail: 'Recorded' });
    el.setAttribute('style', setupBannerStyle('failure'));
    el.textContent = '';
    rows.forEach(function (row) {
        const line = document.createElement('div');
        line.setAttribute('style', 'display:flex;align-items:center;gap:12px;');
        const copy = document.createElement('span');
        copy.setAttribute('style', 'font:600 16px/1.35 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;');
        copy.textContent = row.label + ' — ' + row.detail;
        line.appendChild(setupCheckMark(row.ok));
        line.appendChild(copy);
        el.appendChild(line);
    });
    const note = document.createElement('p');
    note.setAttribute('style', 'margin:8px 0 0;font:400 13px/1.45 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;color:#949BB8;');
    note.textContent = 'Ensure you have pasted the exact script from your offer. If you still see this error, see if there is another way to paste code in your website editor as sometimes only one method works. If you still see this, do not worry, please reach out to support at hi@getrevtrack.com and we will help you troubleshoot this.';
    el.appendChild(note);
}

function noteSetupConversion(ok, data) {
    if (!isSetupCheck()) return;
    const message = data && typeof data.message === 'string' ? data.message : '';
    if (ok && /recorded successfully/i.test(message)) showSetupCheckSuccess();
    else showSetupCheckFailure();
}



function getDeviceType() {
    const ua = navigator.userAgent || '';
    const hints = navigator.userAgentData;
    if (hints && hints.mobile === true) {
        return 'mobile';
    }
    if (/iPad|Tablet|Android(?!.*Mobile)/i.test(ua)) return 'tablet';
    if (/Mobi|Android|iPhone|iPod/i.test(ua)) return 'mobile';
    return 'desktop';
}

function getLanguage() {
    return navigator.language || (navigator.languages && navigator.languages[0]) || null;
}

// Function to extract offer name from Podia URL
function extractOfferNameFromPodiaUrl(url) {
    try {
        const urlObj = new URL(url);
        const pathParts = urlObj.pathname.split('/');
        
        // Check if the URL follows the pattern /thanks/offer-name
        if (pathParts.length >= 3 && pathParts[1] === 'thanks') {
            // Extract the offer name (everything after /thanks/)
            // This handles offer names with or without query parameters
            return pathParts[2].split('?')[0];
        }
        
        console.log("URL doesn't match expected Podia thank you page format");
        return null;
    } catch (error) {
        console.error("Error parsing URL:", error);
        return null;
    }
}

// Function to get IP address
async function getIpAddress() {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('Error fetching IP:', error);
        return null;
    }
}

function hasValidResource(resourceClicked) {
    return !!(
        resourceClicked
        && resourceClicked.name
        && resourceClicked.type
        && resourceClicked.name !== 'NA'
        && resourceClicked.type !== 'NA'
        && String(resourceClicked.name).trim() !== ''
        && String(resourceClicked.type).trim() !== ''
    );
}

function getOfferName() {
    const isPodia = getMetaContentByName('revtrack_is_podia') === 'true';
    if (isPodia) {
        const offerName = extractOfferNameFromPodiaUrl(window.location.href);
        if (!offerName) {
            console.log("Could not extract offer name from Podia URL");
            return null;
        }
        console.log("Extracted offer name from Podia URL:", offerName);
        return offerName;
    }
    return getMetaContentByName('offer');
}

function getPurchasePrice() {
    let price = getMetaContentByName('RevTrackPrice');

    if (price === 'custom') {
        const urlParams = new URLSearchParams(window.location.search);
        const urlPrice = urlParams.get('rtprice');
        if (urlPrice) {
            let sanitizedPrice = urlPrice
                .replace(/^[$€£¥₹₽R$C$A$NZ$HK$S$Fr]+/, '')
                .replace(/[^\d.]/g, '')
                .trim();

            const numericPrice = parseFloat(sanitizedPrice);
            if (!isNaN(numericPrice) && numericPrice >= 0) {
                price = numericPrice.toString();
                console.log("Using custom price from URL parameter:", price);
            } else {
                console.log("Invalid rtprice URL parameter (not a valid number):", urlPrice);
                price = null;
            }
        } else {
            console.log("Custom price specified but no rtprice URL parameter found");
            price = null;
        }
    }

    return price;
}

async function sendPurchaseByIp(username, offerName, price, userInfo) {
    if (!username || !offerName) {
        console.log("Cannot send IP-based purchase: missing username or offer");
        showSetupCheckFailure();
        return;
    }

    const ipAddress = await getIpAddress();
    if (!ipAddress) {
        console.log("Cannot send IP-based purchase: no IP address");
        return;
    }

    const payload = {
        offer: offerName,
        ip_address: ipAddress,
        device: getDeviceType(),
        language: getLanguage()
    };
    if (isSetupCheck()) payload.isTest = true;
    if (price) {
        payload.price = price;
    }

    console.log("Sending IP-based purchase info:", payload);

    fetch(`https://${trackingHost(THANK_YOU_SERVER_URL)}/api/purchase-by-ip/${username}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    })
    .then(response => response.json().then(data => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
            noteSetupConversion(ok, data);
        console.log('IP-based purchase response:', data);
        if (userInfo && data && !data.error) {
            if (!userInfo.purchases) {
                userInfo.purchases = {};
            }
            userInfo.purchases[offerName] = true;
            setCookie('userInfo', JSON.stringify(userInfo), 30);
            const localStorageKey = `purchase_${offerName}`;
            localStorage.setItem(localStorageKey, 'true');
        }
    })
    .catch((error) => {
        showSetupCheckFailure();
        console.error('Error sending IP-based purchase info:', error);
    });
}

// Function to send user info to the server after purchase
async function sendPurchaseInfoToServer(userInfo) {
    console.log("Checking if purchase info can be sent...");
    console.log("UserInfo received:", userInfo);
    console.log("Full userInfo.purchases object:", JSON.stringify(userInfo.purchases));
    
    const username = userInfo.username || getMetaContentByName('username');

    // Ensure the username is present
    if (!username) {
        console.log("Username is missing.");
        showSetupCheckFailure();
        return;
    }

    const offerName = getOfferName();
    if (!offerName) {
        console.log("Offer name is missing.");
        showSetupCheckFailure();
        return;
    }

    console.log("Offer name:", offerName);

    // Check localStorage first to prevent duplicate sends
    const localStorageKey = `purchase_${offerName}`;
    if (!isSetupCheck() && localStorage.getItem(localStorageKey) === 'true') {
        console.log(`Purchase for offer "${offerName}" already tracked in localStorage. Skipping.`);
        return;
    }

    // Check if the purchase for this offer has already been recorded in cookie
    if (!isSetupCheck() && userInfo.purchases && userInfo.purchases[offerName]) {
        console.log("Purchase for this offer has already been recorded in cookie.");
        // Mark in localStorage so we don't check again
        localStorage.setItem(localStorageKey, 'true');
        console.log(`Marked purchase for ${offerName} as tracked in localStorage`);
        return;
    }

    const price = getPurchasePrice();
    
    // Determine the resource to associate with the sale
    let resourceClicked = userInfo.resourceClicked;

    // If there are funnel steps for this offer, use the resource from the latest step
    if (userInfo.funnelSteps && userInfo.funnelSteps[offerName] && userInfo.funnelSteps[offerName].length > 0) {
        // Get the most recent funnel step's resource
        const latestStep = userInfo.funnelSteps[offerName][userInfo.funnelSteps[offerName].length - 1];
        if (latestStep.resource) {
            resourceClicked = latestStep.resource;
            console.log("Using resource from latest funnel step:", resourceClicked.name);
        }
    }
    // If no funnel steps but there's a call booking, use that resource
    else if (userInfo.callBookings && userInfo.callBookings[offerName]) {
        // Use the resource associated with the call booking
        resourceClicked = userInfo.callBookings[offerName];
        console.log("Using resource from call booking:", resourceClicked.name);
    }
    // If no funnel steps but there's an email signup, use that resource
    else if (userInfo.emailSignups && userInfo.emailSignups[offerName]) {
        // Use the resource associated with the email signup
        resourceClicked = userInfo.emailSignups[offerName];
        console.log("Using resource from email signup:", resourceClicked.name);
    }

    if (!hasValidResource(resourceClicked)) {
        console.log("Resource clicked is missing; will try IP lookup on server:", resourceClicked);
    }

    // Create the payload to send to the server
    const payload = {
        username: username,
        tag: userInfo.tag,
        offer: offerName, // Include the offer name in the payload
        lead_id: userInfo.lead_id, // Add lead_id from userInfo
        device: getDeviceType(),
        language: getLanguage(),
        initial_referrer: userInfo.initial_referrer || null
    };
    if (isSetupCheck()) payload.isTest = true;

    const ipAddress = await getIpAddress();
    if (ipAddress) {
        payload.ip_address = ipAddress;
    }

    if (hasValidResource(resourceClicked)) {
        payload.resourceClicked = resourceClicked;
    }
    
    // Add price to payload if available
    if (price) {
        payload.price = price;
        console.log("Including price in payload:", price);
    }
    
    // Add split test if available in userInfo
    if (userInfo.splitTest) {
        payload.splitTest = userInfo.splitTest;
        console.log("Including split test in payload:", userInfo.splitTest);
    }
    
    console.log("Sending purchase info:", payload);

    // Make the POST request to the server with the username in the URL
    fetch(`https://${trackingHost(THANK_YOU_SERVER_URL)}/api/purchase/${username}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),  // Send the user info, resourceClicked, and lead_id in the request body
    })
    .then(response => response.json().then(data => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
            noteSetupConversion(ok, data);
        console.log('Response from server:', data);
        // Update the userInfo cookie to mark that the purchase has been made for this offer
        if (!userInfo.username) {
            userInfo.username = username;
        }
        if (!userInfo.purchases) {
            userInfo.purchases = {};
        }
        userInfo.purchases[offerName] = true;  // Mark the purchase for this specific offer
        
        // Update the cookie only after a successful purchase
        setCookie('userInfo', JSON.stringify(userInfo), 30);  // Update the cookie for 30 days
        
        // Mark as sent in localStorage after successful response
        localStorage.setItem(localStorageKey, 'true');
        console.log(`Purchase for ${offerName} marked as tracked in localStorage`);
    })
    .catch((error) => {
        showSetupCheckFailure();
        console.error('Error sending purchase info:', error);
    });
}

// Core logic — extracted so it can run immediately in a React SPA where
// DOMContentLoaded has already fired before initializeThankYou() is called.
async function runThankYouSetup() {
    pingSetupCheck();
    ensureSetupCheckBanner();
    const userInfoCookie = getCookie('userInfo');
    if (userInfoCookie) {
        const userInfo = JSON.parse(userInfoCookie);
        sendPurchaseInfoToServer(userInfo);
    } else {
        console.log("No userInfo found in cookies.");
        const username = getMetaContentByName('username');
        const offerName = getOfferName();
        console.log("Attempting IP-based purchase tracking for username:", username);
        sendPurchaseByIp(username, offerName, getPurchasePrice(), null);
    }
}

// In a React SPA, DOMContentLoaded has already fired by the time useEffect
// calls initializeThankYou(), so run immediately in that case.
if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', runThankYouSetup);
} else {
    runThankYouSetup();
}

}
